// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3yxJ7","label":"Labeled_label__1JJF3","divider":"Labeled_divider__1e27o"};